/**
 * 集計情報
 */
export class SumInfo {
    /** 検査項目名(複数) */
    inspectionNames = ""
    /** 検査分類名(複数：重複なし) */
    classificationNames = ""
    /** 小計 */
    amount = 0
    /** 消費税 */
    tax = 0
    /** 手数料 */
    fee = 0

    /**
     * コンストラクタ
     * @param init 
     */
    constructor(init?: Partial<SumInfo>) {
        Object.assign(this, init)
    }
}
